import React from 'react';
import ReactDom from 'react-dom';
import Moment from 'moment';

import Const from 'fw_const';
import Utils from 'utils';
import CastingCommon from '@utils/casting-common';

import Sortable from 'react-sortablejs';
import ContentsModal from 'contents_modal';

import ProgressCard from './progress-card';
import ProgressGroupModal from './progress-group-modal';
import ProgressAdditionInfluencer from './progress-addition-influencer';

import ClientCheckHistoryModal from './client-check-history-modal';

// -------------------------------------------------------

const Tooltip = ({children}) => children || null;
const OverlayTrigger = ({children}) => children || null;

class ProgressSpace extends React.Component {
  constructor(props) {
    super(props);
    this.init(props);
  }

  init(props) {
    this.state = {
      group_data: {},
      group_modal: false,
      influencer_modal: false,
      memo_modal: false,
      memo_list: [],
      last_read_count: 0 // 既読数管理用
    };
  }

  componentDidMount() {
    this.loadReadCount();
  }

  /**
   * localStorageから既読件数を読み込む
   */
  getReadCountKey() {
    const { base, progress } = this.props;
    return 'memo_read_count_' + base.project.id + '_' + progress.id;
  }

  loadReadCount() {
    const key = this.getReadCountKey();
    const count = parseInt(localStorage.getItem(key) || '0', 10);
    this.setState({ last_read_count: count });
  }

  /**
   * 特殊形式のJSON解析
   */
  parseMemoJson(memoStr) {
    if (!memoStr || memoStr === '""' || memoStr === '{}' || memoStr === '[]') return [];
    try {
      var cleanStr = memoStr;
      if (typeof cleanStr === 'string' && cleanStr.charAt(0) === '"' && cleanStr.charAt(cleanStr.length - 1) === '"') {
        cleanStr = cleanStr.substring(1, cleanStr.length - 1);
      }
      cleanStr = cleanStr.replace(/\\\"/g, '"').replace(/\\\\n/g, '\n');
      var fn = new Function('return ' + cleanStr);
      var result = fn();
      return Array.isArray(result) ? result : [];
    } catch (e) {
      console.error("Memo Parse Error:", e);
      return [];
    }
  }

  toggleGroupModal(flg, data) {
    this.setState({ group_modal: flg, group_data: data });
  }

  toggleMemoModal(flg) {
    var base = this.props.base;
    var progress = this.props.progress;

    if (flg) {
      // モーダルを開くとき、最新のプロップスからメモリストを復元
      var memo_list = [];
      try {
        var group_memo = (base.workflow.workflow_group_memo && base.workflow.workflow_group_memo[progress.id]) ? base.workflow.workflow_group_memo[progress.id] : {};
        memo_list = this.parseMemoJson(group_memo.memo_json);
      } catch (e) {}

      // 【既読処理】開いた時点の件数を保存
      localStorage.setItem(this.getReadCountKey(), memo_list.length);
      
      this.setState({ 
        memo_modal: true, 
        memo_list: memo_list,
        last_read_count: memo_list.length 
      });
    } else {
      this.setState({ memo_modal: false });
    }
  }

  /**
   * メモ保存
   */
  saveMemo(text, user) {
    var newEntry = {
      user_id: user.id,
      name: user.name,
      text: text,
      date: Moment().format('YYYY-MM-DD HH:mm:ss'),
      type: 'insert',
    };

    var updatedList = this.state.memo_list.concat([newEntry]);
    
    // 自分が投稿した場合は即座に既読扱いにする
    localStorage.setItem(this.getReadCountKey(), updatedList.length);
    this.setState({ last_read_count: updatedList.length });

    this.updateMemoApi(updatedList);
  }

  /**
   * メモ削除
   */
  deleteMemo(index) {
    if (!confirm("このメモを削除しますか？")) return;
    var updatedList = this.state.memo_list.filter(function(_, i) { return i !== index; });
    
    // 削除後も整合性を取るため既読数を更新
    localStorage.setItem(this.getReadCountKey(), updatedList.length);
    this.setState({ last_read_count: updatedList.length });

    this.updateMemoApi(updatedList);
  }

  /**
   * メモ更新用共通API通信
   */
  updateMemoApi(updatedList) {
    var _this = this;
    var base = this.props.base;
    var progress = this.props.progress;

    var payload = {
      project_id: base.project.id,
      progress: progress.id,
      memo_json: JSON.stringify(updatedList)
    };

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/project/workflow/update_group_memo', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          _this.setState({ memo_list: updatedList });
          if (base.event && base.event.refreshWorkflow) {
            base.event.refreshWorkflow();
          }
        } else {
          alert("メモの更新に失敗しました。");
        }
      }
    };
    xhr.send(JSON.stringify(payload));
  }

  render() {
    var base = this.props.base;
    var progress = this.props.progress;
    var list = this.props.list || [];
    
    var group_memo = {};
    try {
      if (base.workflow.workflow_group_memo[progress.id] != undefined) group_memo = base.workflow.workflow_group_memo[progress.id];
    } catch (e) {}
    
    var currentMemos = this.parseMemoJson(group_memo.memo_json);
    var memoCount = currentMemos.length;

    // 未読判定：現在の件数が、最後に保存した件数より多ければ未読あり
    var hasUnread = memoCount > this.state.last_read_count;

    return (
      <div className={'progress-space ' + progress.id} data-id={progress.id}>
        <ProgressHeader 
          progress={progress} 
          list={list} 
          memo_count={memoCount}
          has_unread={hasUnread}
          toggle_ev={this.toggleGroupModal.bind(this)} 
          open_memo_ev={this.toggleMemoModal.bind(this, true)}
        />

        {(progress.parent != undefined) &&
          <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>グループの移動</Tooltip>}>
            <i className="material-icons handle">open_in_full</i>
          </OverlayTrigger>
        }

        <Sortable options={{ group: 'shared', animation: 150 }} tag="ul" className="progress-scroll" onChange={this.props.change_ev.bind(this)}>
          {list.map(function(d, key) {
            if (base.ng_view_mode == 'true' && d.is_ng == 1) return null;
            return <ProgressCard key={key} data={d} base={base} />;
          })}
          {(progress.id == 'candidate' || progress.id == 'stock') && <ProgressAdditionInfluencer base={base} />}
        </Sortable>

        <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>グループを追加</Tooltip>}>
          <div className="add-group" onClick={this.toggleGroupModal.bind(this, true, { progress: progress.id, order_no: progress.order_no, parent: progress.parent })}>+</div>
        </OverlayTrigger>

        <ExcelDownload base={base} progress={progress} list={list} />
        <BulkActions base={base} progress={progress} list={list} />

        <ProgressGroupModal view={this.state.group_modal} data={this.state.group_data} base={base} list_count={list.length} close_ev={this.toggleGroupModal.bind(this)} project_id={base.project.id} />

        <ProgressMemoModal 
          view={this.state.memo_modal}
          title={progress.name}
          list={this.state.memo_modal ? this.state.memo_list : currentMemos}
          close_ev={this.toggleMemoModal.bind(this, false)}
          save_ev={this.saveMemo.bind(this)}
          delete_ev={this.deleteMemo.bind(this)}
          user={base.userData}
        />
      </div>
    );
  }
}

// -------------------------------------------------------

class ProgressHeader extends React.Component {
  render() {
    var progress = this.props.progress;
    var list = this.props.list;
    var memoCount = this.props.memo_count || 0;
    
    // クラス名の制御
    var memoBtnClass = "memo-btn";
    if (memoCount === 0) {
      memoBtnClass += " is-empty";
    } else if (this.props.has_unread) {
      memoBtnClass += " has-unread";
    }

    return (
      <div className="progress-header">
        {(progress.group_id != undefined)
          ? <h2 className="group-name edit" onClick={this.props.toggle_ev.bind(this, true, { group_id: progress.group_id, name: progress.name, help: progress.help })}>
            {progress.name}<i className="material-icons">edit</i>
          </h2>
          : <h2 className="group-name">{progress.name}</h2>
        }
        <h6 className="group-help">{progress.help}</h6>
        <div className="header-actions">
          <div className={'group-score score-' + list.length}>{Utils.viewInt(list.length)}</div>
          <div className={memoBtnClass} onClick={this.props.open_memo_ev}>
            <i className="material-icons">chat</i><p>{memoCount}</p>
          </div>
        </div>
      </div>
    );
  }
}

// -------------------------------------------------------

class ProgressMemoModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { text: '' };
    this.chatListRef = null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.view && (!prevProps.view || prevProps.list.length !== this.props.list.length)) {
      this.scrollToBottom();
    }
  }

  scrollToBottom() {
    if (this.chatListRef) {
      this.chatListRef.scrollTop = this.chatListRef.scrollHeight;
    }
  }

  handleSend() {
    if (!this.state.text.trim()) return;
    this.props.save_ev(this.state.text, this.props.user);
    this.setState({ text: '' });
  }

  renderMessage(text) {
    if (!text) return "";
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    var parts = text.split(urlRegex);
    return parts.map(function(part, i) {
      if (part.match(urlRegex)) {
        return <a key={i} href={part} target="_blank" rel="noopener noreferrer">{part}</a>;
      }
      return part;
    });
  }

  render() {
    if (!this.props.view) return null;
    var _this = this;
    var currentUser = this.props.user || {};

    return (
      <div className="memo-modal-overlay" onClick={this.props.close_ev}>
        <div className="memo-modal-content" onClick={function(e){ e.stopPropagation(); }}>
          <div className="memo-header">
            <h3>{this.props.title} - メモ</h3>
            <i className="material-icons close-icon" onClick={this.props.close_ev}>close</i>
          </div>
          <div className="memo-chat-list" ref={function(el){ _this.chatListRef = el; }}>
            {this.props.list.length === 0 && <p className="empty-msg">メモはありません</p>}
            {this.props.list.map(function(m, i) {
              return (
                <div key={i} className="chat-item">
                  <div className="chat-meta">
                    <div>
                      <span className="chat-name">{m.name}</span>
                      <span className="chat-date" style={{marginLeft:'8px'}}>{m.date}</span>
                    </div>
                    {(m.user_id == currentUser.id) && 
                      <i className="material-icons delete-memo-btn" onClick={_this.props.delete_ev.bind(_this, i)}>delete_outline</i>
                    }
                  </div>
                  <div className="chat-bubble">{_this.renderMessage(m.text)}</div>
                </div>
              );
            })}
          </div>
          <div className="memo-footer">
            <textarea 
              placeholder="メモを入力..." 
              value={this.state.text} 
              onChange={function(e){ this.setState({ text: e.target.value }); }.bind(this)}
              onKeyDown={function(e){ if(e.ctrlKey && e.keyCode === 13) this.handleSend(); }.bind(this)}
            />
            <button className="send-btn" onClick={this.handleSend.bind(this)}>送信</button>
          </div>
        </div>
      </div>
    );
  }
}

// -------------------------------------------------------

class ExcelDownload extends React.Component {
  render() {
    var base = this.props.base;
    var progress = this.props.progress;
    var list = this.props.list;
    var ng_mode = (base.ng_view_mode == 'true') ? 'not_ng' : 'all';
    if (list.length > 0) {
      return (
        <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>リストをEXCEL形式でダウンロード</Tooltip>}>
          <a className="report-download on" href={'/api/excel/workflow/influencers/' + base.project.id + '/' + progress.id + '/' + ng_mode} target="_blank">
            <i className="material-icons">download</i>
          </a>
        </OverlayTrigger>
      );
    } else {
      return <a className="report-download off"><i className="material-icons">download</i></a>;
    }
  }
}

// -------------------------------------------------------

class BulkActions extends React.Component {
  render() {
    var base = this.props.base;
    var progress = this.props.progress;
    var list = this.props.list;
    if (progress.id == 'client_check') {
      var targets = [];
      list.map(function(d) {
        var request_action = CastingCommon.getRequestAction(base, d.insta_user_id, 'full_task');
        if (request_action == 'client_check') targets.push(d.insta_user_id);
      });
      return (
        <div className="bulk-box">
          <p className={"bulk-action client-check " + (targets.length > 0 ? "on" : "off")} onClick={targets.length > 0 ? base.event.showClientCheckModal.bind(this, targets) : null}>まとめてチェックを依頼</p>
          <ClientCheckHistoryModal base={base} />
        </div>
      );
    }
    if (progress.id == 'assign_target') {
      var targets = list.map(function(d){ return d.insta_user_id; });
      return <p className={"bulk-action first-check " + (targets.length > 0 ? "on" : "off")} onClick={targets.length > 0 ? base.event.showSendFirstDmModal.bind(this, targets) : null}>初回DM送信</p>;
    }
    if (progress.id == 'assign_action') {
      var targets = [];
      list.map(function(d) {
        var request_action = CastingCommon.getRequestAction(base, d.insta_user_id, 'full_task');
        if (request_action == 'assign_action') targets.push(d.insta_user_id);
      });
      return <p className={"bulk-action assign " + (targets.length > 0 ? "on" : "off")} onClick={targets.length > 0 ? base.event.showAssignModal.bind(this, base.project.id, targets) : null}>まとめてアサイン (確認へ)</p>;
    }
    if (progress.id == 'draft') {
      var targets = [];
      list.map(function(d) {
        var request_action = CastingCommon.getRequestAction(base, d.insta_user_id, 'full_task');
        if (request_action == 'draft_action') targets.push(d.insta_user_id);
      });
      return <p className={"bulk-action draft " + (targets.length > 0 ? "on" : "off")} onClick={targets.length > 0 ? base.event.showDraftModal.bind(this, targets) : null}>まとめて下書き依頼 (確認へ)</p>;
    }
    if (progress.id == 'candidate') {
      return <p className={"bulk-action draft " + (list.length > 0 ? "on" : "off")} onClick={list.length > 0 ? base.event.showSelectCandidateModal.bind(this, list) : null}>候補者を表示する</p>;
    }
    return null;
  }
}

export default ProgressSpace;